 import { IAPIResponse } from "@mindmemobile/mm-shared-global";
import { Observable, map } from "rxjs";
import { HttpService, url } from "../../shared/services";
import { IAPIProductAttributesResponseModel, ICreateUpdateAttributeModel } from "../../shared/interfaces";
import { GetProductAttributesResponseModel } from "../../shared/models";

class ProductAttributeService {
  private httpService: HttpService;

  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );
  }

  saveAttribute(
    data: ICreateUpdateAttributeModel
  ): Observable<GetProductAttributesResponseModel> {
    return this.httpService
      .post<
        IAPIResponse<IAPIProductAttributesResponseModel>
      >(url.createAttribtue, data)
      .pipe(
        map((result) =>
          GetProductAttributesResponseModel.deserialize(result.result)
        )
      );
  }
}

export default new ProductAttributeService();
